<template>
    <div class="th-menu-wrapper">
        <div class="th-menu-area text-center"><button class="th-menu-toggle"><i class="fal fa-times"></i></button>
            <div class="mobile-logo"><a href="index"><img src="assets/img/logo.png" alt="大唐思拓"></a></div>
            <div class="th-mobile-menu">
                <ul>
                    <li class="active"><a href="index">网站首页</a></li>

                       <li class="menu-item-has-children"><a href="#">解决方案</a>
                        <ul class="sub-menu submenurow" id="jjfa">
                            <li> <strong>行业解决方案</strong>
                                <a href="solutiona.html">火电管控解决方案</a>
                                <a href="solutionb.html">水电管控解决方案</a>
                                <a href="solutionc.html">风电管控解决方案</a>
                                <a href="solutiond.html">燃机发电管控解决方案</a>
                                <a href="solutione.html">中小水电管控解决方案</a>
                                <a href="solutionf.html">化工企业管控解决方案</a>
                            </li>
                            <li> <strong>领域解决方案</strong>
                                <a href="solution1.html">安全生产智慧管控方案</a>
<a href="solution2.html">智慧安防解决方案</a>
<a href="solution2b.html">安健环数字化管理解决方案</a>
<a href="solution3.html">智慧工地解决方案</a>
<a href="solution4.html">风机智慧定检解决方案</a>
<a href="solution5.html">智能两票解决方案</a>
<a href="solution6.html">智慧外包解决方案</a>
<a href="solution7.html">双重预控智能管理方案</a>
<a href="solution8.html">作业安全智能管控解决方案</a>
<a href="solution9.html">智能锁控解决方案</a>
<a href="solution10.html">有限空间作业智能管控方案</a>
<a href="solution11.html">设备缺陷智能分析解决方案</a>
<a href="solution12.html">在线考试管理解决方案</a>
<a href="solution13.html">智慧食堂一体化解决方案</a>
                            </li></ul></li>
                    <li class="menu-item-has-children"><a href="#">产品与服务</a>
                        <ul class="sub-menu ">
                            <li> <strong>基础模块</strong>
                                <a href="product1.html">生产任务管理</a>
                                <a href="product2.html">设备管理</a>
                                <a href="product3.html">运行管理</a>
                                <a href="product4.html">安全管理</a>
                                <a href="product5.html">班组管理</a>
                                <a href="product6.html">物资管理</a>
                                <a href="product7.html">问题管理</a>
                                <a href="product8.html">在线考试管理</a>
                                <a href="product9.html">职业健康管理</a>
                                <a href="product10.html">标准制度管理</a>
                                <a href="product11.html">案例库管理</a>
                            </li>
                            <li> <strong>增值服务</strong>
                                <a href="product12.html">智能两票管理</a>
                                <a href="product13.html">智慧外包管理</a>
                                <a href="product14.html">智能点检管理</a>
                                <a href="product15.html">全员绩效管理</a>
                                <a href="product16.html">风险评估管理</a>
                                <a href="product17.html">安全生产责任制</a>
                                <strong>特色模块</strong>
                                <a href="product18.html">AI视频分析及预警</a>
                                <a href="product19.html">实时定位和监控</a>
                                <a href="product20.html">智能门禁管理</a>
                                <a href="product21.html">智能锁控管理</a>
                                <a href="product22.html">智能穿戴设备</a>
                                <a href="product23.html">数据采集管理</a>
                            </li>
                        </ul>
                    </li>
                    <li class="menu-item-has-children"><a href="#">商业合作</a>
                                                    <ul class="sub-menu submenurow">
                                                        <li> <strong>商业合作</strong>
                                                            <a href="cooperation.html">合作方式</a>
                                                            <a href="apply">在线申请</a>
                                                        </li>
                                                    </ul>
                                                </li>
                    <li><a href="news">新闻动态</a></li>
                    <li><a href="about.html">关于我们</a></li>
                </ul>
            </div>
        </div>
    </div>
    <header class="th-header header-layout7">
        <div class="header-top">
            <div class="container">
                <div class="header-top-inner">
                    <div class="row justify-content-center justify-content-md-between align-items-center gy-2">
                        <div class="col-auto d-none d-md-block">
                            <div class="header-links d-none d-md-block">
                                <ul>
                                    <li><i class="fal fa-phone"></i><a href="tel:4006988915">400-6988-915</a></li>

                                </ul>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="header-links">
                                <ul>

                                    <li>
                                        <div class="header-social">
                                            <a href="about.html"><i class="fab fa-weibo"></i></a>
                                            <a href="about.html"><i class="fab fa-weixin"></i></a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sticky-wrapper">
            <div class="sticky-active">
                <div class="menu-area">
                    <div class="container">
                        <div class="row align-items-center justify-content-between">
                            <div class="col-auto">
                                <div class="logo-style1"><a href="index"><img src="assets/img/logo.png" alt="img"></a>
                                </div>
                            </div>
                            <div class="col-auto">
                                <div class="row align-items-center">
                                    <div class="col-auto">
                                        <nav class="main-menu d-none d-lg-inline-block">
                                            <ul>
                                                <li><a href="index">网站首页</a></li>
                                                  <li class="menu-item-has-children"><a href="#">解决方案</a>
                        <ul class="sub-menu submenurow" id="jjfa">
                            <li> <strong>行业解决方案</strong>
                                <a href="solutiona.html">火电管控解决方案</a>
                                <a href="solutionb.html">水电管控解决方案</a>
                                <a href="solutionc.html">风电管控解决方案</a>
                                <a href="solutiond.html">燃机发电管控解决方案</a>
                                <a href="solutione.html">中小水电管控解决方案</a>
                                <a href="solutionf.html">化工企业管控解决方案</a>
                            </li>
                            <li> <strong>领域解决方案</strong>
                                <a href="solution1.html">安全生产智慧管控方案</a>
<a href="solution2.html">智慧安防解决方案</a>
<a href="solution2b.html">安健环数字化管理解决方案</a>
<a href="solution3.html">智慧工地解决方案</a>
<a href="solution4.html">风机智慧定检解决方案</a>
<a href="solution5.html">智能两票解决方案</a>
<a href="solution6.html">智慧外包解决方案</a>
<a href="solution7.html">双重预控智能管理方案</a>
<a href="solution8.html">作业安全智能管控解决方案</a>
<a href="solution9.html">智能锁控解决方案</a>
<a href="solution10.html">有限空间作业智能管控方案</a>
<a href="solution11.html">设备缺陷智能分析解决方案</a>
<a href="solution12.html">在线考试管理解决方案</a>
<a href="solution13.html">智慧食堂一体化解决方案</a>
                            </li></ul></li>
                                                <li class="menu-item-has-children "><a href="#">产品与服务</a>
                                                    <ul class="sub-menu submenurow">
                                                        <li> <strong>基础模块</strong>
                                                            <a href="product1.html">生产任务管理</a>
                                                            <a href="product2.html">设备管理</a>
                                                            <a href="product3.html">运行管理</a>
                                                            <a href="product4.html">安全管理</a>
                                                            <a href="product5.html">班组管理</a>
                                                            <a href="product6.html">物资管理</a>
                                                            <a href="product7.html">问题管理</a>
                                                            <a href="product8.html">在线考试管理</a>
                                                            <a href="product9.html">职业健康管理</a>
                                                            <a href="product10.html">标准制度管理</a>
                                                            <a href="product11.html">案例库管理</a>
                                                        </li>
                                                        <li> <strong>增值服务</strong>
                                                            <a href="product12.html">智能两票管理</a>
                                                            <a href="product13.html">智慧外包管理</a>
                                                            <a href="product14.html">智能点检管理</a>
                                                            <a href="product15.html">全员绩效管理</a>
                                                            <a href="product16.html">风险评估管理</a>
                                                            <a href="product17.html">安全生产责任制</a>
                                                            <strong>特色模块</strong>
                                                            <a href="product18.html">AI视频分析及预警</a>
                                                            <a href="product19.html">实时定位和监控</a>
                                                            <a href="product20.html">智能门禁管理</a>
                                                            <a href="product21.html">智能锁控管理</a>
                                                            <a href="product22.html">智能穿戴设备</a>
                                                            <a href="product23.html">数据采集管理</a>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li class="menu-item-has-children"><a href="#">客户</a>
                                                    <ul class="sub-menu submenurow">
                                                        <li> <strong>典型案例</strong>
                                                            <a href="client1.html">安全生产管控</a>
                                                            <a href="client2.html">企业标准化管理</a>
                                                            <a href="client3.html">全员绩效管理</a>
                                                            <a href="client4.html">其他管控</a>
                                                        </li>
                                                        <li> <strong>增值服务</strong>
                                                            <a href="client5.html">火电企业客户</a>
                                                            <a href="client5.html#parta">水电企业客户</a>
                                                            <a href="client5.html#partb">风电企业客户</a>
                                                            <a href="client5.html#partc">电网公司客户</a>
                                                            <a href="client5.html#partd">化工企业客户</a>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li class="menu-item-has-children"><a href="#">服务</a>
                                                    <ul class="sub-menu submenurow">
                                                        <li> <strong>服务与支持</strong>
                                                            <a href="service1.html">产品实施</a>
                                                            <a href="service2.html">产品部署</a>
                                                            <a href="service3.html">常见问题</a>
                                                        </li>

                                                    </ul>
                                                </li>
                                                <li class="menu-item-has-children"><a href="#">商业合作</a>
                                                    <ul class="sub-menu submenurow">
                                                        <li> <strong>商业合作</strong>
                                                            <a href="cooperation.html">合作方式</a>
                                                            <a href="apply">在线申请</a>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li><a href="news">新闻动态</a></li>
                                                <li><a href="about.html">关于我们</a></li>
                                            </ul>
                                        </nav><button type="button" class="th-menu-toggle d-inline-block d-lg-none"><i
                                                class="far fa-bars"></i></button>
                                    </div>
                                    <div class="col-auto d-none d-xl-block">
                                        <div class="header-button"><a href="about.html"
                                                class="th-btn style3 ml-25">联系我们<i
                                                    class="fas fa-arrow-right ms-2"></i></a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>


    <main class="fix">


        <div class="breadcumb-wrapper productbreadcumb" data-bg-src="assets/img/bg/breadcumb-bg2.jpg"
            style="background-image: url(assets/img/bg/breadcumb-bg2.jpg);">
            <div class="container">
                <div class="breadcumb-content">
                    <h1 class="breadcumb-title">在线申请</h1>
                    <ul class="breadcumb-menu">
                        <li><a href="index">首页</a></li>
                        <li>商务合作</li>
                        <li>在线申请</li>
                    </ul>
                </div>
            </div>
        </div>

        <section class="blog-post-area">

            <div class="container">
                <div class="title-area text-center">
                    <div class="shadow-title">Online</div><span class="sub-title6 justify-content-center"><span
                            class="shape left"><span class="dots"></span></span>
                        商业合作<span class="shape right"><span class="dots"></span></span></span>
                    <h2 class="sec-title">在线申请</h2>
                </div>
                <div class="row justify-content-center">
                        <form class="row g-3" @submit.prevent="validateForm">
                            <div class="col-12">
                                <label for="inputAddress" class="form-label req">公司名称</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="inputAddress"
                                    v-model="formData.companyName"
                                />
                                <p v-if="errors.companyName" class="text-danger">{{ errors.companyName }}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label req">成立时间</label> 
                                <a-date-picker class="form-control" v-model:value="formData.establishmentTime" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"/>
                                <p v-if="errors.establishmentTime" class="text-danger">{{ errors.establishmentTime }}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label req">注册资金（万元）</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formData.registeredCapital"
                                />
                                <p v-if="errors.registeredCapital" class="text-danger">{{ errors.registeredCapital }}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label req">联系人</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formData.contact"
                                />
                                <p v-if="errors.contact" class="text-danger">{{ errors.contact }}</p>
                            </div>
                            <div class="col-md-4">
                                <label for="inputPassword4" class="form-label req">职务</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formData.position"
                                />
                                <p v-if="errors.position" class="text-danger">{{ errors.position }}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label req">电话</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formData.phone"
                                />
                                <p v-if="errors.phone" class="text-danger">{{ errors.phone }}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label req">邮箱</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    v-model="formData.email"
                                />
                                <p v-if="errors.email" class="text-danger">{{ errors.email }}</p>
                            </div>
                            <div class="col-12">
                                <label for="inputAddress2" class="form-label">地址</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formData.address"
                                />
                            </div>
                            <div class="col-12">
                                <label for="inputAddress2" class="form-label req">主营业务</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formData.mainBusiness"
                                />
                                <p v-if="errors.mainBusiness" class="text-danger">{{ errors.mainBusiness }}</p>
                            </div>
                            <div class="col-12">
                                <label for="inputAddress2" class="form-label req">公司简介</label>
                                <textarea
                                    class="form-control"
                                    rows="2"
                                    v-model="formData.companyProfile"
                                ></textarea>
                                <p v-if="errors.companyProfile" class="text-danger">{{ errors.companyProfile }}</p>
                            </div>
                            <div class="col-12">
                                <label for="inputAddress2" class="form-label">留言</label>
                                <textarea
                                    class="form-control"
                                    rows="2"
                                    v-model="formData.message"
                                ></textarea>
                            </div>
                            <div style="text-align: center;">
                                <button type="submit" class="btn btn-primary">提交</button>
                                &nbsp;
                                <button
                                    type="button"
                                    class="btn btn-outline-primary"
                                    @click="resetForm"
                                >
                                    重置
                                </button>
                            </div>
                        </form>
                    </div>



            </div>
        </section>
    </main>




    <footer class="footer-wrapper footer-layout2" style="background-image: url(assets/img/bg/footer2-bg.png);">
        <div class="widget-area space-top">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-md-6 col-xxl-5 col-xl-4">
                        <div class="widget footer-widget">
                            <div class="th-widget-about style2">
                                <div class="about-logo"><a href="index"><img src="assets/img/logo2.png" alt="img"></a>
                                </div>
                                <p class="about-text">
                                    大唐思拓是一家致力于推动客户实现高质量发展和高水平安全的智能安全管控专家。大唐思拓始终以先进的人工智能、大数据和物联网技术为核心动力，致力于以优质的产品和服务推动企业安全管理升级、智能化改造、经济增长和社会进步。依托于人工智能和数字化技术，大唐思拓专注于为企业提供简单易用、实用管用的智能化产品，帮助客户完成数字化转型，发展新质生产力，实现高质量发展和高水平安全。
                                </p>
                                <div class="footer-info-grid">
                                    <div class="footer-info-wrap">
                                        <h6 class="footer-info-title">咨询热线</h6>
                                        <div class="footer-info"><i class="fas fa-phone"></i> <a href="tel:4006988915"
                                                class="info-box_link">4006988915</a></div>
                                    </div>
                                    <div class="footer-info-wrap">
                                        <h6 class="footer-info-title">联系电话</h6>
                                        <div class="footer-info"><i class="fas fa-phone"></i> <a href="tel:01082051185"
                                                class="info-box_link">01082051185</a></div>
                                    </div>
                                </div>
                                <div class="footer-info-grid">
                                    <div class="footer-info-wrap">
                                        <h6 class="footer-info-title">微信公众号</h6>
                                        <div><img src="assets/img/code.jpg"></div>
                                    </div>
                                    <div class="footer-info-wrap">
                                        <h6 class="footer-info-title">微博官方号</h6>
                                        <div><img src="assets/img/weibo.jpg"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">解决方案</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">
                                    <li><a href="solution1.html">安全生产智慧管控方案</a></li>
                                    <li><a href="solution2.html">智慧安防高效解决方案</a></li>
                                    <li><a href="solution2b.html">安健环数字化管理解决方案</a></li>
                                    <li><a href="solution3.html">智慧工地一体解决方案</a></li>
                                    <li><a href="solution4.html">风机智慧定检解决方案</a></li>
                                    <li><a href="solution5.html">智能两票综合解决方案</a></li>
                                    <li><a href="solution6.html">智慧外包管理解决方案</a></li>
                                    <li><a href="solution7.html">双重预控智能管理方案</a></li>
                                    <li><a href="solution8.html">作业安全智能管控解决方案</a></li>
                                    <li><a href="solution9.html">智能锁控集成解决方案</a></li>
                                    <li><a href="solution10.html">有限空间作业智能管控方案</a></li>
                                    <li><a href="solution11.html">设备缺陷智能分析方案</a></li>
                                    <li><a href="solution12.html">在线考试管理解决方案</a></li>
                                    <li><a href="solution13.html">智慧食堂一体化解决方案</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">基础服务</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">
                                    <li><a href="product1.html">生产任务管理</a></li>
                                    <li><a href="product2.html">设备管理</a></li>
                                    <li><a href="product3.html">运行管理</a></li>
                                    <li><a href="product4.html">安全管理</a></li>
                                    <li><a href="product5.html">班组管理</a></li>
                                    <li><a href="product6.html">物资管理</a></li>
                                    <li><a href="product7.html">问题管理</a></li>
                                    <li><a href="product8.html">在线考试管理</a></li>
                                    <li><a href="product9.html">职业健康管理</a></li>
                                    <li><a href="product10.html">标准制度管理</a></li>
                                    <li><a href="product11.html">案例库管理</a></li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">增值服务</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">
                                    <li><a href="product12.html">智能两票管理</a></li>
                                    <li><a href="product13.html">智慧外包管理</a></li>
                                    <li><a href="product14.html">智能点检管理</a></li>
                                    <li><a href="product15.html">全员绩效管理</a></li>
                                    <li><a href="product16.html">风险评估管理</a></li>
                                    <li><a href="product17.html">安全生产责任制</a> </li>
                                </ul>
                            </div>
                        </div>
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">特色模块</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">
                                    <li><a href="product18.html">AI视频分析及预警</a></li>
                                    <li><a href="product19.html">实时定位和监控</a></li>
                                    <li><a href="product20.html">智能门禁管理</a></li>
                                    <li><a href="product21.html">智能锁控管理</a></li>
                                    <li><a href="product22.html">智能穿戴设备</a></li>
                                    <li><a href="product23.html">数据采集管理</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="copyright-wrap">
            <div class="container">
                <div class="row justify-content-between align-items-center">
                    <div class="col-md-6">
                        <p class="copyright-text">Copyright © 2024 <a href="index">北京大唐思拓信息技术有限公司</a> All Rights
                            Reserved.
                        </p>
                    </div>
                    <div class="col-md-6 text-end d-none d-md-block">
                        <div class="footer-links">
                            <ul>
                                <li><a href="about.html">京ICP备19044307号</a></li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>


    <div class="scroll-top"><svg class="progress-circle svg-content" width="100%" height="100%" viewbox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
                style="transition: stroke-dashoffset 10ms linear 0s; stroke-dasharray: 307.919, 307.919; stroke-dashoffset: 307.919;">
            </path>
        </svg></div>




</template>

<script setup> 
import { reactive, onMounted } from "vue";
import http from '@/shared/http.service';
import { Uris } from "@/shared/const";
import dayjs from 'dayjs';

onMounted(() => {
    var _53code = document.createElement("script");
    _53code.src = "https://tb.53kf.com/code/code/2680b6cabfa62183adeadc2c928410477/1";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(_53code, s);

});
// 表单数据
const formData = reactive({
    companyName: "",
    establishDate: "",
    registeredCapital: "",
    contactPerson: "",
    position: "",
    phone: "",
    email: "",
    mainBusiness: "",
    companyDescription: "",
    address:"",
    message:"",
});

// 表单验证错误
const errors = reactive({});
// 表单验证逻辑
const validateForm = () => {
    
    // 清空错误
    Object.keys(errors).forEach((key) => (errors[key] = ""));
    // 验证每个字段
    let isValid = true;
    if (!formData.companyName) {
        errors.companyName = "公司名称不能为空";
        isValid = false;
    }  
    
    if (!formData.establishmentTime) {
        errors.establishmentTime = "成立时间不能为空";
        isValid = false;
    }

    if (!formData.registeredCapital) {
        errors.registeredCapital = "注册资金不能为空";
        isValid = false;
    }
    if (!formData.contact) {
        errors.contact = "联系人不能为空";
        isValid = false;
    }
    if (!formData.position) {
        errors.position = "职务不能为空";
        isValid = false;
    }
    if (!formData.phone) {
        errors.phone = "电话不能为空";
        isValid = false;
    }
    if (!formData.email) {
        errors.email = "邮箱不能为空";
        isValid = false;
    }
    if (!formData.mainBusiness) {
        errors.mainBusiness = "主营业务不能为空";
        isValid = false;
    }
    if (!formData.companyProfile) {
        errors.companyProfile = "公司简介不能为空";
        isValid = false;
    } 
    // 时间格式只要年月日
    // formData.establishmentTime=dayjs(formData.establishmentTime).format('YYYY-MM-DD');
    // 如果验证通过，提交数据
    if (isValid) {
      // 发送 POST 请求到后端 API
        return http.post(Uris.AddOnlineApply, formData).subscribe(t=>{
        if(t>0)
        {
            alert("提交成功！");
            resetForm(); 
        }else
        {
            alert("提交失败，请联系客服");
        }
      }); 
      
       
    }
};

// 重置表单
const resetForm = () => {
    Object.keys(formData).forEach((key) => (formData[key] = ""));
    Object.keys(errors).forEach((key) => (errors[key] = ""));
};

</script>

<style>
.footer-layout2:after {
    width: 800px !important;
}

.footer-layout2 {
    padding-top: 0;
}

.req:before {  
    content: '*';
    color: red;
}
.form-control .ant-picker-input{

     height: 50px;
   
}
</style>